module.exports = __webpack_public_path__ + "img/tavoloWhite.7bf28bc1.svg";